<template>
  <v-dialog v-model="dialogLocal" max-width="600px" @click:outside="close">
    <v-card>
      <v-card-title>
        Adjuntar archivo a: {{ nodoName || 'Nodo' }}
      </v-card-title>
      <v-card-text>
        <!-- documentos de un armario: van siempre en una de sus carpetas (las llenas no se pueden elegir) -->
        <v-alert v-if="requiereCarpeta && !carpetas.length" dense text type="warning" class="mb-3">
          Este armario no tiene carpetas: elígelas primero en su documentación («Carpetas»).
        </v-alert>
        <v-select
          v-if="carpetas.length"
          v-model="idCarpeta"
          :items="opcionesCarpeta"
          item-text="texto"
          item-value="id"
          item-disabled="lleno"
          label="Carpeta"
          prepend-inner-icon="mdi-folder-outline"
          outlined
          dense
          :hint="todasLlenas ? 'Todas las carpetas están llenas: elimina un documento para subir otro' : ''"
          persistent-hint
          class="mb-2"
        />
        <v-text-field
          v-model="nombreArchivo"
          label="Nombre del archivo"
          required
        />
        <v-textarea
          v-model="descripcionArchivo"
          label="Descripción (opcional)"
          rows="3"
        />
        <v-file-input
          v-model="archivoAdjunto"
          label="Selecciona archivo"
          accept="*/*"
          required
          show-size
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="close">Cancelar</v-btn>
        <v-btn color="primary" :disabled="(requiereCarpeta || carpetas.length > 0) && !idCarpeta" @click="submit">Subir</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    nodoName: String,
    // carpetas del armario [{ id, nombre, limite, documentos }] y la elegida al abrir
    carpetas: { type: Array, default: () => [] },
    // los documentos de armario no se pueden subir sin carpeta (los del cliente no tienen)
    requiereCarpeta: { type: Boolean, default: false },
    carpetaInicial: { type: [Number, String], default: null },
  },
  data() {
    return {
      nombreArchivo: '',
      descripcionArchivo: '',
      archivoAdjunto: null,
      dialogLocal: false,
      idCarpeta: null,
    }
  },
  computed: {
    opcionesCarpeta() {
      return this.carpetas.map((c) => ({
        id: c.id,
        texto: `${c.nombre} (${c.documentos}/${c.limite})`,
        lleno: c.documentos >= c.limite,
      }));
    },
    todasLlenas() {
      return this.opcionesCarpeta.length > 0 && this.opcionesCarpeta.every((c) => c.lleno);
    },
  },
  watch:{
    dialog(newVal) {
      this.dialogLocal = newVal
      if (newVal) {
        // la carpeta pedida si tiene hueco; si no, la primera con hueco
        const libre = (id) => this.opcionesCarpeta.find((c) => c.id === Number(id) && !c.lleno)
        this.idCarpeta = (libre(this.carpetaInicial) || this.opcionesCarpeta.find((c) => !c.lleno) || {}).id || null
      }
    },
    // al elegir el archivo se propone su nombre (sin la extensión) si aún no hay uno
    archivoAdjunto(archivo) {
      if (archivo && !this.nombreArchivo) this.nombreArchivo = archivo.name.replace(/\.[^.]+$/, '') || archivo.name
    },
    dialogLocal(newVal) {
      if (!newVal) {
        this.$emit('update:dialog', false)
      }
    }
  },
  mounted(){
    this.dialogLocal = this.dialog
  },
  methods: {
    close() {
      this.$emit('update:dialog', false)
      this.resetFields()
    },
    resetFields() {
      this.nombreArchivo = ''
      this.descripcionArchivo = ''
      this.archivoAdjunto = null
    },
    submit() {
      // Puedes validar aquí
      if (!this.nombreArchivo || !this.archivoAdjunto) {
        this.$avisar('Completa todos los campos requeridos', "warning")
        return
      }
      this.$emit('upload', {
        nombreArchivo: this.nombreArchivo,
        descripcionArchivo: this.descripcionArchivo,
        archivoAdjunto: this.archivoAdjunto,
        idCarpeta: this.carpetas.length ? this.idCarpeta : null
      })
      this.close()
    }
  }
}
</script>
